import styled, { css } from 'styled-components'
import media from 'styled-media-query'

type HeaderButtonContainerProps = {
  width: string
  positionInPage: boolean
}

export const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  .textarea-container {
    padding: 20px;
  }

  ${media.lessThan('medium')`
    padding: 0 36px;
  `}
`

export const RegistrationContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 20px;

  ${media.lessThan('medium')`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${media.lessThan('small')`
    grid-template-columns: repeat(1, 1fr);
  `}
`

export const TitleContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: ${theme.font.sizes.medium};
    color: ${theme.colors.primary};
    margin: 30px 18px 0;
    border-bottom: 2px solid ${theme.colors.primary};

    > button {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin: 0 0 7px 0;
      width: 20%;

      > svg {
        position: absolute;
        left: 25px;
      }
    }

    ${media.lessThan('medium')`
      > button {
        display: none;
      }
    `}
  `}
`

export const Title = styled.h2`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    font-size: ${theme.font.sizes.medium};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.primary};
  `}
`

export const HeaderButtonContainer = styled.div<HeaderButtonContainerProps>`
  ${({ width, positionInPage }) => css`
    display: flex;
    width: ${width};
    gap: 1rem;

    > button {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin: 0 0 7px 0;

      > svg {
        position: absolute;
        left: 15px;
      }
    }

    ${positionInPage &&
    css`
      position: absolute;
      right: 18px;
      top: -48px;
    `}

    ${media.lessThan('huge')`
      > button svg {
        display: none;
      }
    `}

    ${media.lessThan('medium')`
      display: none;
    `}
  `}
`

export const TitleWithButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: ${theme.font.sizes.medium};
    color: ${theme.colors.primary};
    margin: 40px 18px;
    padding-bottom: 10px;
    border-bottom: 2px solid ${theme.colors.primary};
    position: relative;

    .button-add {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: ${theme.font.semiBold};
      color: ${theme.colors.primary};
      background: none;
      border-color: ${theme.colors.primary};
      height: 40px;
      width: 180px;
      cursor: pointer;
      transition: all ${theme.transition.default};

      svg {
        position: absolute;
        right: 12px;
        top: 17px;

        path {
          fill: ${theme.colors.primary};
        }
      }

      &:hover {
        background: ${theme.colors.primary};
        color: ${theme.colors.white};

        svg path {
          fill: ${theme.colors.white};
        }
      }
    }

    ${media.lessThan('medium')`
      font-size: ${theme.font.sizes.small};

      > button {
        width: 30%;

        > svg {
          display: none;
        }
      }
    `}

    ${media.lessThan('small')`
      font-size: ${theme.font.sizes.xsmall};

      > button {
        width: 46%;
      }
    `}
  `}
`

export const DropdownContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 243px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    border-radius: ${theme.border.radius} ${theme.border.radius} 0 0;
    padding: 0 14px;
    overflow: auto;
    position: absolute;
    background-color: white;
    right: 0;
    top: 50px;
    z-index: 1;

    > button {
      margin-bottom: 10px;
    }

    div {
      margin: 20px 0;
    }

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.primary};
      border-radius: 10px;
    }
  `}
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 2.6rem;

  > button {
    text-align: center;
    position: relative;
    width: 35%;

    > svg {
      position: absolute;
      left: 15px;
    }
  }

  ${media.lessThan('medium')`
    flex-direction: column;
      > button {
        width: 80%;
      }
  `}

  ${media.lessThan('small')`
    > button svg {
      display: none
    }
  `}
`

export const MenuContainer = styled.div`
  ${({ theme }) => css`
    max-width: 308px;
    width: 100%;
    background: ${theme.colors.white};
    max-height: 200px;
    overflow-y: scroll;
    position: absolute;
    border-radius: ${theme.border.radius};
    z-index: 3;

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.primary};
      border-radius: 10px;
    }
  `}
`

export const CpfsMenu = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    cursor: pointer;
    padding: 14px 10px;
    border-radius: ${theme.border.radius};

    &:hover {
      background: ${theme.colors.primary};
      color: ${theme.colors.white};
    }
  `}
`
